"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.driverTypes = void 0;
exports.driverTypes = {
    SET_LOADING: 'DRIVER TYPES SET LOADING',
    SET_ERROR: 'DRIVER TYPES REDUCER SET ERROR',
    SET_DATA_GRID: 'DRIVER TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'DRIVER TYPES ON PAGE CHANGE',
    ON_MUTATION_CLICK: 'DRIVER TYPES ON MUTATION',
    ON_SORT_CHANGE: 'DRIVER TYPES ON SORT CHANGE',
    ON_SAVE_DATAITEM: 'DRIVER TYPES ON SAVE DATAITEM',
    ON_FILTER_CHANGE: 'DRIVER TYPES ON FILTER CHANGE',
    ON_DELETE_DATAITEM: 'DRIVER TYPES ON DELETE DATAITEM',
    ON_CHANGE_DATAITEM: 'DRIVER TYPES ON CHANGE DATAITEM',
    TOGGLE_SUCCESS_MODAL: 'DRIVER TYPES SET SUCCESS MODAL',
    SET_DATA_CONTRACTOR: 'DRIVER TYPES GET DATA CONTRACTOR',
};
